<template>
<div class="recruit">
  <el-container>
    <el-header id="top">
        <div class="container nav"
         v-bind:class="{ 'navActive': scrollFlag }">
          
          <el-menu
            :default-active="activerecruit"
            class="el-menu-demo"
            mode="horizontal"
           
            @select="handleSelect"
           
            >
            <div class="logo"><img src="../assets/logo.png" ></div>
            <el-menu-item index="6" class="hr">诚聘英才</el-menu-item>
            <el-menu-item index="5" @click="toBg6">联系我们</el-menu-item>
            <el-menu-item index="4" @click="toBg5">软件著作权</el-menu-item>
            <el-menu-item index="3" @click="toBg4">合作伙伴</el-menu-item>
            <el-menu-item index="2" @click="toBg3">业务介绍</el-menu-item>
            <el-menu-item index="1" @click="goIndex">首页</el-menu-item>
            
          </el-menu>
        </div>
        <div class="scrollbg" v-if="scrollFlag"></div>
        <div class="container bg1txt">
          <div class="bg1txtl">诚聘英才</div>
          <div  class="bg1txts"><span class="bg1line"></span> JOIN US <span class="bg1line"></span></div>
          <div class="bg1txt2">有意者请将个人简历以及职位发送至hr邮箱:yanpeiqi@changingpay.com。请勿直接到访，恕不接待。</div>
            
        </div>
    </el-header>
    <div class="container bg2">
      <div class="tab first" @click="tabToggle" v-bind:class="{ active: isActive1 }"><div class="line" v-if="isActive1"></div> 运营专员(杭州)</div>
      <div class="tab second" @click="tabToggle2" v-bind:class="{ active: !isActive1 }"><div class="line" v-if="!isActive1"></div>软件工程师</div>
      <div class="through"></div>
      <div class="con" v-if="isActive1">
          <div class="title">工作地点:</div>
          <div class="txt">浙江银联杭州市环城北路169号</div>
          <div class="title">岗位职责:</div>
          <div class="txt">·负责公司的日常运营工作及公司客户的日常维护 <br>
                            ·从用户角度，追踪整体业务流程中的运营情况，收集用户问题和需求，针对性分析问题，提出优化建议并跟进实现<br>
                            ·负责对平台进行用户数据分析，负责平台周报、月报、季报、年报的撰写等</div>
            <div class="title">任职资格:</div>
            <div class="txt">
                ·大专学历，一年以上工作经验，有互联网金融、第三方支付行业相关工作经验者优先<br>
·熟悉office办公软件，精通Excel、PPT、Word操作<br>
·能独立承担工作任务，对工作有计划、控制能力<br>
·具有一定的分析判断能力、观察力和洞察力；有迅速的的反应能力和问题解决能力 <br>
·工作积极主动、细致、责任心强，有良好的团队协作精神及沟通协调能力，具备良好的总结意识和分析习惯，善于推动工作流程
            </div>
      </div>
      <div class="con" v-if="!isActive1">
          <div class="title">岗位职责:</div>
          <div class="txt">·业务需求的沟通 <br>
                            ·功能模块详细设计<br>
                            ·业务功能实现与单元测试<br>
                            ·系统维护</div>
            <div class="title">任职资格:</div>
            <div class="txt">
                ·计算机相关专业本科及以上学历<br>
·熟练掌握JSP、Servlet、XML、JDBC、AJAX、HTML、Javascript、CSS等相关技术<br>
·熟悉常用的J2EE开发框架（Struts、Spring、Mybatis等）<br>
·2年以上J2EE项目开发经验 <br>
·工作积极主动，具有良好的文档能力、学习能力、沟通能力及团队合作精神
            </div>
      </div>
    </div>
    <el-footer class="footer">
        <div class="container">
            <div class="nav">
              <div class="navcon" @click="goIndex">首页</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg3">业务介绍</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg4">合作伙伴</div>
              <div class="navline"></div>
              <div class="navcon long" @click="toBg5">软件著作权</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg6">联系我们</div>
              <div class="navline"></div>
              <div class="navcon" >诚聘英才</div>
              
            </div>
            <div class="copyright">
              <div class="left">
                <div class="title1">上海清裔钲商务咨询有限公司 贵阳清钲金融科技有限公司(c)</div>
                <div class="title2" @click="gobeian">2016-{{ currentYear }} All Rights Reserved 黔ICP备17007172号-1</div>
              </div>
              <div class="right">
                <div class="logo"><img src="../assets/logo.png" ></div>
              </div>
              
            </div>
          </div>  
      </el-footer>
  </el-container>
</div>
</template>

<script>

export default {
  name: 'HelloWorld',
  data () {
    return {
      currentYear: new Date().getFullYear(),
      activerecruit: '',
      scrollFlag:false,
      isActive1:true,
      isActive2:false

    }
  },
  methods: {
      tabToggle(){
          this.isActive1=true
      },
      tabToggle2(){
          this.isActive1=false
      },
      gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      goIndex(){
        sessionStorage.setItem('nav','index')
        this.$router.push('/')
      },
      goAboutUs(){
        this.$router.push('/aboutus')
      },
      toTop(e){
        document.getElementById("top").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toBg3(){
         sessionStorage.setItem('nav','Bg3')
         this.$router.push('/')
      },
      toBg4(){
        sessionStorage.setItem('nav','Bg4')
         this.$router.push('/')
      },
      toBg5(){
        sessionStorage.setItem('nav','Bg5')
         this.$router.push('/')
      },
      toBg6(){
        sessionStorage.setItem('nav','Bg6')
         this.$router.push('/')
      },
      handleSelect(key, keyPath) {
        
      },
      handleScroll () {
        let _this=this;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop)
        if(scrollTop){
          _this.scrollFlag=true
        }else{
          _this.scrollFlag=false
        }
      },
      
      
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)
  }
} 

</script>
<style scoped>
.recruit .footer{
  width: 100%;
  margin-top: 90px;
  height: 330px!important;
  background-image: url("../assets/bg_06.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;

}
.recruit .footer .copyright{
  margin-top: 30px;
  overflow: hidden;

}
.recruit .footer .copyright .left{
  float: left;
  text-align: left;
}
.recruit .footer .copyright .left .title1{
  font-family: PingFangSC-Semibold;
font-size: 14px;
color: #FFFFFF;
font-weight: 600;
}
.recruit .footer .copyright .left .title2{
font-family: PingFangSC-Regular;
font-size: 14px;
color: #848991;
margin-top: 4px;
cursor: pointer;
}
.recruit .footer .copyright .right{
  float: right;
  margin-top: -6px;
}
.recruit .footer .nav{
  margin-top: 110px;
}
.recruit .footer .navcon{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
float: left;
width: 94px;
cursor: pointer;
}
.recruit .footer .navcon.long{
width: 109px;
}
.recruit .footer .navcon:hover{
  opacity: 0.5;
  color:#fff
}
.recruit .footer .navcon:first-child{
text-align: left;
width: 50px;
}

.recruit .footer .navline{
  width: 1px;
  height: 16px;
  display: block;
  float: left;
  background: #DBBA66;
  margin-top: 3.5px;
}
.recruit>>>.el-carousel{
  
}

.recruit>>>.el-carousel__button{
width: 40px;
height: 6px;
background: #F1F1F1;
opacity: 1;
cursor: pointer;
}
.recruit>>>.el-carousel__indicator.is-active button{
  background: #DBBA66;
}
.recruit>>>.el-carousel__mask{
  background-color: transparent;
  opacity: 0;
}
 .carousel-img {
    max-width: 100%;
    max-height: 100%;
  }

  
  .el-carousel__item:nth-child(2n) {
   
  }
  
  .el-carousel__item:nth-child(2n+1) {
    
  }
.recruit{
 height: 100%;
}
.recruit .el-fade-in-linear-leave-active{
  transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.recruit .el-fade-in-linear-enter-active{
transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.recruit .scrollbg{
  height: 80px;
}
.recruit .el-main{
  padding: 0;
    margin-top: -140px;

}

.recruit .logo{
  display: block;
  float: left;
  width: 200px;
  height: 60px;
  
 
}
.recruit .nav{
  width: 100%!important;
  height: 80px;
  background: rgba(11,21,37,0.80);
  overflow: hidden;
}

.recruit .logo img{
  width: 200px;
  height: 60px;
}
.recruit .el-header{
  height: 480px!important;
  width: 100%;
  line-height: 80px;
  background-image: url("../assets/header_join_us.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;
  padding: 0;
  
  position: relative;
}

.recruit .container{
  width: 1080px;
  margin: 0 auto;
  position: relative;
}
.recruit .bg2{
  height: 600px;
  background: #FFFFFF;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.10), 0 0 30px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
margin-top: -120px;
position: relative;
}
.recruit .bg2 .tab{
    background: #FFFFFF;
border-radius: 4px;
border-radius: 4px;
width: 280px;
height: 80px;
line-height: 80px;
font-weight: 600;
text-align: center;
font-family: PingFangHK-Semibold;
font-size: 22px;
color:  #DDDDDD;
position: relative;
margin-left: 40px;
margin-top: 40px;
cursor:pointer;
text-align: left;
padding-left: 40px;
}
.recruit .bg2 .tab .line{
    position: absolute;
    background: #DD2C2C;
    width: 4px;
    height: 20px;
    left: 20px;
    top: 30px;
}
.recruit .bg2 .active{
    background: #F6F6F6;
    color: #333333;
}
.recruit .bg2 .through{
    background: #DDDDDD;
border-radius: 1px;
border-radius: 1px;
width: 2px;
height: 520px;
position: absolute;
top: 40px;
left: 400px;
}
.recruit .bg2 .con{
    width: 540px;
    height: 520px;
    float: right;
    padding: 20px 50px;
    margin-top: -150px;
    text-align: left;

}
.recruit .bg2 .con .title{
    font-family: PingFangSC-Semibold;
font-size: 18px;
color: #333333;
text-align: justify;
font-weight: 600;
margin-bottom: 10px;
}
.recruit .bg2 .con .txt{
    font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
text-align: justify;
margin-bottom: 30px;
line-height: 25px;
}
.recruit .bg2 .first{

}
.recruit .bg2 .second{
margin-top: 0;
}




.recruit .bg1txt{
  margin-top: 70px;
  display: block;
  overflow: hidden;
}
.recruit .bg1txt .bg1txtl{
  font-family: SourceHanSerifCN-Heavy;
font-size: 50px;
color: #FFFFFF;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}
.recruit .bg1txt .bg1txts{
font-family: TimesNewRomanPS-BoldMT;
font-size: 28px;
color: #FFFFFF;
letter-spacing: 3px;
text-align: center;
margin-top: -20px;
}
.recruit .bg1txt .bg1txt2{
font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
letter-spacing: 0;
text-align: center;
margin-top: -25px;
}
.recruit .bg1txt .bg1txts .bg1line{
width: 17px;
height: 1px;
background-color: #fff;
display: inline-block;
margin-bottom: 8px;
}
.recruit .bg1txt .button{
  width: 220px;
  height: 60px;
  margin-top: 46px;
  background-image: url("../assets/button.png");
  background-repeat: no-repeat;
  background-size: cover;
  font-family: PingFangSC-Medium;
font-size: 20px;
color: #08192F;
text-align: left;
line-height: 58px;
cursor: pointer;
}
.recruit .el-menu.el-menu--horizontal{
  border-bottom:none;
  background:transparent;
  width: 1080px;
  margin: 10px auto;
}
.recruit .el-menu--horizontal>.el-menu-item{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
padding: 0 15px;
float: right;
}
.recruit .hr{
  border: 1px solid #FFFFFF!important;
border-radius: 4px;
border-radius: 4px;
width: 100px;
height: 40px;
line-height: 40px;
margin-top: 9px;
margin-left: 12px;


}
.recruit .el-menu--horizontal>.el-menu-item:hover{
  background-color: transparent;
  opacity: 0.5;
  color:#fff
}
.recruit .el-menu--horizontal>.el-menu-item.is-active{
  color: #fff;
  background-color: transparent;
  border-bottom: 1px solid #DBBA66;
}
.recruit .navActive{
position: fixed;
top: 0;
    background: rgba(11,21,37,0.80);
   
z-index: 100;
height: 80px;

}
</style>